import api from './client';

export interface ProfitRecommendation {
  title: string;
  action: string;
  expected_impact: string;
}

export interface ProfitSnapshot {
  id: number;
  period_start: string;
  period_end: string;
  order_count: number;
  gross_revenue: number;
  total_discounts: number;
  total_refunds: number;
  est_payment_fees: number;
  ad_spend: number;
  net_profit: number;
  profit_margin_percent: number;
  ai_summary: string | null;
  ai_recommendations: ProfitRecommendation[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GenerateProfitPayload {
  days?: number;
  ad_spend?: number;
}

export const profitApi = {
  list: (page = 1) =>
    api.get<{ data: ProfitSnapshot[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/profit-insights?page=${page}`
    ),

  generate: (payload: GenerateProfitPayload = {}) =>
    api.post<{ data: ProfitSnapshot }>('/profit-insights/generate', payload),

  show: (id: number) => api.get<{ data: ProfitSnapshot }>(`/profit-insights/${id}`),

  destroy: (id: number) => api.delete(`/profit-insights/${id}`),
};
